import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
const KONAMI_CODE = ["ArrowUp", "ArrowDown", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight", "ArrowDown", "ArrowUp"];
export const useKonamiCode = (enabled, onActivate) => {
  const $ = _c(5);
  const [activated, setActivated] = useState(false);
  let t0;
  let t1;
  if ($[0] !== activated || $[1] !== enabled || $[2] !== onActivate) {
    t0 = () => {
      if (!enabled || activated) {
        return;
      }
      const sequence = [];
      const handleKeyDown = e => {
        sequence.push(e.code);
        if (sequence.length > KONAMI_CODE.length) {
          sequence.shift();
        }
        if (sequence.join(",") === KONAMI_CODE.join(",")) {
          setActivated(true);
          onActivate?.();
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    };
    t1 = [enabled, activated, onActivate];
    $[0] = activated;
    $[1] = enabled;
    $[2] = onActivate;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return activated;
};